import React from 'react'
import { connect } from 'react-redux'

import { CONSULTANT } from 'userTypes'
import { userTypeSelector } from 'selectors'

import Home from '../Home'
import Profile from './Profile'

const Component = ({ userType, ...rest }) =>
  userType === CONSULTANT ? <Home {...rest} /> : <Profile {...rest} />

const mapStateToProps = state => ({
  userType: userTypeSelector(state),
})

export default connect(mapStateToProps)(Component)



// WEBPACK FOOTER //
// ./src/pages/Profile/index.js